<form #mainForm="ngForm" class="editForm" novalidate>
    <h1 class="text-center">Wie hoch ist Ihre Immobilienrente?</h1>
    <p class="text-center">Jetzt <span style="color:#799df3;font-weight:bold;">100% kostenfrei und unverbindlich</span> ermitteln lassen</p>
    <div class="tab-pane fade in active">
        <div class="text-center">
            <h4 class="main">{{title}}</h4>
        </div>
        <div class='row'>
            <div class='col-xs-offset-1 col-xs-10'>
                <div class="row">
                    <div class='col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-6'>
                        <input class="item p-0 h-0" type="image" src="assets/images/icon_house.gif" name="type" (click)="goToNext('174370000');$event.preventDefault();">
                    </div>
                    <div class='col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-6'>
                        <input class="item p-0 h-0" type="image" src="assets/images/icon_appartment.gif" name="type" (click)="goToNext('174370001');$event.preventDefault();">
                    </div>
                </div>
                    
            </div>
        </div>
    </div>
</form>

<app-footer [progress]="0"></app-footer>